export const NAME = "buyerProfiles"
export const FIREBASE_PATH = "buyerProfiles"
